import React from 'react';
import { FilterContainer } from '../common/filters/FilterContainer';
import { SingleItemFilter, SingleItemFilterItems } from '../common/filters/SingleItemFilter';
import { DateRangeFilter } from '../common/filters/DateRangeFilter';
import { FilterClearButton } from '../common/filters/FilterClearButton';
import { Grid } from '@material-ui/core';
import { useFilterContext } from '../common/filters/FilterContext';
import { SearchFieldFilter } from '../common/filters/SearchFieldFilter';

type InvoiceStatus = boolean | null;

const statusFilterItems: SingleItemFilterItems<InvoiceStatus> = [
  { label: 'Unpaid', value: false },
  { label: 'Paid', value: true },
];

const FilterBarRight: React.FC = () => {
  const { filters, setAllFilters } = useFilterContext();

  return (
    <Grid container spacing={2}>
      <Grid item>
        <SingleItemFilter<InvoiceStatus>
          label={'Status'}
          items={statusFilterItems}
          columnId={'Status'}
        />
      </Grid>
      <Grid item>
        <DateRangeFilter
          label={'Issue Date'}
          labelStart={'Issued From'}
          labelEnd={'Issued To'}
          columnId={'InvoiceDate'}
        />
      </Grid>
      <Grid item>
        <DateRangeFilter
          label={'Due Date'}
          labelStart={'Due From'}
          labelEnd={'Due To'}
          columnId={'DueDate'}
        />
      </Grid>
      <Grid item>
        <FilterClearButton onClick={() => setAllFilters([])} isActive={Boolean(filters.length)}>
          Clear All
        </FilterClearButton>
      </Grid>
    </Grid>
  );
};

export const FilterBar: React.FC = () => {
  return (
    <FilterContainer
      left={
        <SearchFieldFilter placeholder={'Search by Invoice Number'} columnId={'InvoiceNumber'} />
      }
      right={<FilterBarRight />}
    />
  );
};
